import { render, staticRenderFns } from "./LikeButton.vue?vue&type=template&id=08b416f3&scoped=true"
import script from "./LikeButton.vue?vue&type=script&lang=ts"
export * from "./LikeButton.vue?vue&type=script&lang=ts"
import style0 from "./LikeButton.vue?vue&type=style&index=0&id=08b416f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b416f3",
  null
  
)

export default component.exports